// JSON-LD schemas for the Heranças page (Service, FAQ, Breadcrumb)
export const serviceSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "serviceType": "Avaliação Imobiliária para Heranças e Partilhas",
  "provider": {
    "@type": "ProfessionalService",
    "name": "Valuare JR",
    "address": {
      "@type": "PostalAddress",
      "addressCountry": "PT"
    },
    "priceRange": "€€",
    "telephone": "+351915964080",
    "email": "admin@valuarejr.com"
  },
  "areaServed": {
    "@type": "Country",
    "name": "Portugal"
  },
  "description": "Avaliações imobiliárias certificadas por Perito Avaliador registado na CMVM para heranças indivisas, partilhas entre herdeiros e processos sucessórios, com enquadramento na Lei n.º 49/2026 e em conformidade com as European Valuation Standards 2025."
};

export const faqSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": [
    {
      "@type": "Question",
      "name": "É necessário o acordo de todos os herdeiros para pedir a avaliação?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Não. Basta que o cabeça-de-casal, ou quem detenha a chave, faculte o acesso ao imóvel. O relatório é único e serve todos os interessados."
      }
    },
    {
      "@type": "Question",
      "name": "Qual o valor do serviço?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Os honorários dependem da tipologia, da localização, da finalidade e da complexidade documental. Não são uma percentagem do valor apurado. A proposta é enviada no próprio dia, sem compromisso."
      }
    },
    {
      "@type": "Question",
      "name": "Quanto tempo demora?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "O relatório é entregue em cinco a oito dias úteis após a vistoria, que demora entre trinta e quarenta e cinco minutos."
      }
    },
    {
      "@type": "Question",
      "name": "A avaliação das Finanças não chega?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Não. O Valor Patrimonial Tributário destina-se à liquidação do IMI e não corresponde ao valor de mercado."
      }
    },
    {
      "@type": "Question",
      "name": "O relatório é aceite pelo notário?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Sim. O relatório pode ser apresentado no cartório notarial, na conservatória e em tribunal. No crédito bancário, cada banco costuma exigir a avaliação que ele próprio encomenda."
      }
    },
    {
      "@type": "Question",
      "name": "Já existem vários herdeiros em desacordo. Ainda faz sentido?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Sim, e é nesses casos que mais se justifica. A avaliação independente substitui opinião contra opinião por um documento fundamentado e verificável."
      }
    }
  ]
};

export const breadcrumbSchema = {
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  "itemListElement": [
    {
      "@type": "ListItem",
      "position": 1,
      "name": "Início",
      "item": typeof window !== 'undefined' ? window.location.origin : 'https://valuarejr.com'
    },
    {
      "@type": "ListItem",
      "position": 2,
      "name": "Heranças e Partilhas",
      "item": typeof window !== 'undefined' ? `${window.location.origin}/herancas` : 'https://valuarejr.com/herancas'
    }
  ]
};

export const herancasSchemas = [serviceSchema, faqSchema, breadcrumbSchema];
